import { render } from "./ColumnTotals.vue?vue&type=template&id=079c7084"
import script from "./ColumnTotals.vue?vue&type=script&lang=js"
export * from "./ColumnTotals.vue?vue&type=script&lang=js"

import "./ColumnTotals.vue?vue&type=style&index=0&id=079c7084&lang=scss"

import exportComponent from "/app/tmp/blackhall/V3/v2026.19.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__